<mat-expansion-panel #expander [expanded]="isExpanded()" (opened)="setIsCollapsed(false)" (closed)="setIsCollapsed(true)" [disabled]="disabled">
  <mat-expansion-panel-header>
    <mat-panel-title>{{panelTitle}}</mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content *ngIf="expander.expanded"></ng-content>
</mat-expansion-panel>